import { Dialog } from '@mui/material';
import { useCallback } from 'react';

import { useModalStore } from 'common/hooks/useModals';
import ModalShell from './ModalShell';

function View({ isOpen, handleClose }) {
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      fullWidth
      maxWidth="sm"
    >
      <ModalShell />
    </Dialog>
  );
}

function Model() {
  const {
    changeRegistration,
    setChangeRegistrationState,
  } = useModalStore();

  const { isOpen } = changeRegistration;

  const handleClose = useCallback(() => {
    setChangeRegistrationState(false);
  }, [setChangeRegistrationState]);

  const hookProps = {
    isOpen,
    handleClose,
  };

  return (
    <View
      {...hookProps}
    />
  );
}

export default Model;
export { View };
